<template>
    <div class='w-full px-6 py-3 bg-gray-100 h-[calc(100%-5rem)] overflow-y-auto'>
        <div class="flex flex-col">
            <div class="flex space-x-2 items-center justify-start h-9">
                <label class="w-20 text-sm text-gray-600 tracking-wide">From:</label>
                <div class="border-b flex items-center border-gray-300 outline-none h-9 w-full">
                    {{ emailFrom }}
                </div>
            </div>
            <div v-if="emailTo" class="flex space-x-2 items-center justify-start h-9">
                <label class="w-20 text-sm text-gray-600 tracking-wide">To:</label>
                <div class="border-b flex items-center border-gray-300 outline-none h-9 w-full">
                    {{ emailTo }}
                </div>
            </div>
            <div class="flex space-x-2 items-center justify-start h-9">
                <label class="w-20 text-sm text-gray-600 tracking-wide">Bcc:</label>
                <div class="border-b flex items-center border-gray-300 outline-none h-9 w-full">
                    {{ emailBcc }}
                </div>
            </div>
            <div class="flex space-x-2 items-center justify-start h-9">
                <label class="w-20 text-sm text-gray-600 tracking-wide">Subject:</label>
                <div class="border-b flex items-center border-gray-300 outline-none h-9 w-full">
                    {{ emailSubject }}
                </div>
            </div>
            <div v-if="crmActionType" class="flex space-x-2 items-center justify-start h-9">
                <label class="w-24 text-sm text-gray-600 tracking-wide whitespace-nowrap">CRM Detail:</label>
                <div class="border-b flex items-center border-gray-300 outline-none h-9 w-full">
                    {{ crmActionType }}
                </div>
            </div>
        </div>
        <div class="w-full pt-4 h-[calc(100%-13rem)]">
            <div class="flex flex-row h-full">
                <div class="w-full h-full">
                    <div ref="emailBodyContainer" class="bg-white w-full h-full rounded-md border border-gray-300 p-4 overflow-auto">
                        <div :class="htmlBodyClass" v-html="emailBody"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {defineProps, ref, computed, useTemplateRef } from 'vue';
import { useElementSize } from '@vueuse/core';
import { fillEmptyParagraphs } from '@/utils/emailHtml';

const props = defineProps(['emailTemplate', 'userPermissions'])


const emailBodyContainer = useTemplateRef('emailBodyContainer');
const { width, height } = useElementSize(emailBodyContainer)

const htmlBodyClass = computed(() => {
    return `w-[calc(${Math.floor(width)-32}px)] max-w-[(${Math.floor(width)-32}px)]`
})

const emailFrom = computed(() => {
    return props.emailTemplate && props.emailTemplate.email_from_new ? props.emailTemplate.email_from_new.email_address : null
})

const emailTo = computed(() => {
    return props.emailTemplate && props.emailTemplate.email_to ? props.emailTemplate.email_to.email_address : null
})

const emailBcc = computed(() => {
    return props.emailTemplate && props.emailTemplate.email_bcc ? props.emailTemplate.email_bcc : null
})

const emailSubject = computed(() => {
    return props.emailTemplate && props.emailTemplate.subject ? props.emailTemplate.subject : null
})

const crmActionType = computed(() => {
    return props.emailTemplate && props.emailTemplate.crm_action_type ? props.emailTemplate.crm_action_type.action_name : null
})

const emailBody = computed(() => {
    let body = props.emailTemplate && props.emailTemplate.email_body ? props.emailTemplate.email_body : null
    if(body) {
        if(props.emailTemplate.signature_image) {
            body = body.replace('<img src="cid:signature">' , `<img src="${props.emailTemplate.signature_image}">`)
        }
        if(props.emailTemplate.logo_image) {
            body = body.replace('<img src="cid:logo">' , `<img src="${props.emailTemplate.logo_image}">`)
        }
        if(props.emailTemplate.logo_image_2) {
            body = body.replace('<img src="cid:logo_2">' , `<img src="${props.emailTemplate.logo_image_2}">`)
        }
        // Empty spacer paragraphs are zero-height without this, so the preview
        // showed the template tighter than both the editor and the sent email.
        body = fillEmptyParagraphs(body)
    }
    return body
})
</script>